import React, { useState } from 'react';
import { SectionHeader } from '../components/shared/SectionHeader';
import { AnimatedSection } from '../components/shared/AnimatedSection';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
import { Toast } from '../components/shared/Toast';
import { motion } from 'framer-motion';
export function ContactPage() {
  const [showToast, setShowToast] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setShowToast(true);
    setFormData({
      name: '',
      email: '',
      message: ''
    });
  };
  return <div className="min-h-screen pt-20" data-id="element-309">
      <SectionHeader title="Contact Us" subtitle="Get in touch with our team for your next project" data-id="element-310" />

      <section className="py-16 sm:py-20 md:py-24" data-id="element-311">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-312">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16" data-id="element-313">
            {/* Contact Info */}
            <AnimatedSection data-id="element-314">
              <h3 className="font-heading font-semibold text-2xl sm:text-3xl text-charcoal mb-8" data-id="element-315">
                Get In Touch
              </h3>
              <div className="space-y-6 mb-12" data-id="element-316">
                <div className="flex items-start gap-4" data-id="element-317">
                  <div className="w-12 h-12 bg-cream flex items-center justify-center flex-shrink-0" data-id="element-318">
                    <MapPin size={24} className="text-gold" strokeWidth={1.5} data-id="element-319" />
                  </div>
                  <div data-id="element-320">
                    <h4 className="font-semibold text-charcoal mb-1" data-id="element-321">
                      Address
                    </h4>
                    <p className="text-stone" data-id="element-322">Abuja, Nigeria</p>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-323">
                  <div className="w-12 h-12 bg-cream flex items-center justify-center flex-shrink-0" data-id="element-324">
                    <Phone size={24} className="text-gold" strokeWidth={1.5} data-id="element-325" />
                  </div>
                  <div data-id="element-326">
                    <h4 className="font-semibold text-charcoal mb-1" data-id="element-327">Phone</h4>
                    <p className="text-stone" data-id="element-328">+234 XXX XXX XXXX</p>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-329">
                  <div className="w-12 h-12 bg-cream flex items-center justify-center flex-shrink-0" data-id="element-330">
                    <Mail size={24} className="text-gold" strokeWidth={1.5} data-id="element-331" />
                  </div>
                  <div data-id="element-332">
                    <h4 className="font-semibold text-charcoal mb-1" data-id="element-333">Email</h4>
                    <p className="text-stone" data-id="element-334">info@fdfgold.com</p>
                  </div>
                </div>
              </div>

              {/* Map Placeholder */}
              <div className="bg-cream border border-border h-64 sm:h-80 flex items-center justify-center" data-id="element-335">
                <p className="text-stone" data-id="element-336">Map Placeholder</p>
              </div>
            </AnimatedSection>

            {/* Contact Form */}
            <AnimatedSection data-id="element-337">
              <form onSubmit={handleSubmit} className="bg-white border border-border p-6 sm:p-8 md:p-10" data-id="element-338">
                <h3 className="font-heading font-semibold text-2xl text-charcoal mb-8" data-id="element-339">
                  Send us a message
                </h3>
                <div className="space-y-6" data-id="element-340">
                  <div data-id="element-341">
                    <label className="block text-charcoal font-medium mb-2 text-sm sm:text-base" data-id="element-342">
                      Name
                    </label>
                    <input type="text" value={formData.name} onChange={e => setFormData({
                    ...formData,
                    name: e.target.value
                  })} className="w-full px-4 py-3 sm:py-4 border border-border focus:outline-none focus:border-gold transition-colors text-sm sm:text-base" required data-id="element-343" />
                  </div>
                  <div data-id="element-344">
                    <label className="block text-charcoal font-medium mb-2 text-sm sm:text-base" data-id="element-345">
                      Email
                    </label>
                    <input type="email" value={formData.email} onChange={e => setFormData({
                    ...formData,
                    email: e.target.value
                  })} className="w-full px-4 py-3 sm:py-4 border border-border focus:outline-none focus:border-gold transition-colors text-sm sm:text-base" required data-id="element-346" />
                  </div>
                  <div data-id="element-347">
                    <label className="block text-charcoal font-medium mb-2 text-sm sm:text-base" data-id="element-348">
                      Message
                    </label>
                    <textarea value={formData.message} onChange={e => setFormData({
                    ...formData,
                    message: e.target.value
                  })} rows={5} className="w-full px-4 py-3 sm:py-4 border border-border focus:outline-none focus:border-gold transition-colors resize-none text-sm sm:text-base" required data-id="element-349" />
                  </div>
                  <motion.button type="submit" whileHover={{
                  backgroundColor: '#D4B896'
                }} whileTap={{
                  scale: 0.98
                }} className="w-full bg-gold text-charcoal py-3 sm:py-4 font-semibold transition-colors flex items-center justify-center gap-2 text-sm sm:text-[15px]" data-id="element-350">
                    Send Message
                    <Send size={18} strokeWidth={2} data-id="element-351" />
                  </motion.button>
                </div>
              </form>
            </AnimatedSection>
          </div>
        </div>
      </section>

      <Toast message="Message sent successfully! We'll get back to you soon." type="success" isVisible={showToast} onClose={() => setShowToast(false)} data-id="element-352" />
    </div>;
}